export const normalizeAccountNumber = (value: string): string => value.replace(/\D/g, '');

const accountNumberCandidateRegex = /\b(?:PL[\s_-]*)?\d[\d\s_-]{24,40}\d\b/gi;

const collectAccountCandidates = (text: string, candidates: Set<string>): void => {
  const matches = text.match(accountNumberCandidateRegex) ?? [];

  matches.forEach((match) => {
    const normalized = normalizeAccountNumber(match);
    if (normalized.length === 26) {
      candidates.add(normalized);
    }
  });
};

export const tryExtractAccountNumber = (rawContent: string, fileName: string): string | null => {
  const candidates = new Set<string>();

  collectAccountCandidates(rawContent, candidates);
  collectAccountCandidates(fileName, candidates);

  if (candidates.size === 1) {
    return Array.from(candidates)[0];
  }

  return null;
};
